'use client';
import { getMessaging, deleteToken } from 'firebase/messaging';
import firebaseApp from '@/lib/utils/firebase';
import { storage_keys } from '@/constant/configs';

/**
 * Deletes the FCM token from Firebase and removes it from localStorage
 * This should be called during logout to properly clean up push notification tokens
 */
export const deleteFCMToken = async (): Promise<void> => {
  try {
    // Check if we're in a browser environment
    if (typeof window === 'undefined') {
      return;
    }

    // Get the stored token
    const storedToken = localStorage.getItem(
      storage_keys.firebase_device_token
    );

    if (!storedToken) {
      // No token to delete
      return;
    }

    // Get Firebase messaging instance
    if (firebaseApp) {
      const messaging = getMessaging(firebaseApp);

      // Delete the token from Firebase
      await deleteToken(messaging);
    }

    // Remove from localStorage
    localStorage.removeItem(storage_keys.firebase_device_token);
  } catch (error) {
    // Still remove from localStorage even if Firebase deletion fails
    localStorage.removeItem(storage_keys.firebase_device_token);
  }
};
